<template> 
  <div v-if="section_record_visible"> 
    <span class="title">Records of interest in CovBinderInPDB: </span>
    <button class="selectAll" type="button" v-on:click="click_checkbox"> Download </button> 
    <table border="1" class="dataframe">
      <thead>
        <tr style="text-align: center;">
          <th>Record ID</th>
          <th>Target Residue</th>
          <th>PDB ID</th>
          <th>Chain ID</th>
          <th>Residue Number</th>
          <th>Binder Type</th>
          <th>Warhead Name</th>
          <th>Binder ID</th>
          <th>Binder Mol</th>
          <th>Adduct Mol</th>
          <th>Article DOI</th> 
        </tr>
      </thead>
      <tbody id="instance_record">
        <recordEntry 
          v-for       = "(record,index) in recordData"
          :key        = "index"
          v-bind:record_id     = "record.record_id"
          v-bind:pdb_id        = "record.pdb_id"
          v-bind:chain_id      = "record.chain_id"
          v-bind:res_num       = "record.res_num"
          v-bind:full_res_name = "record.full_residue_name"
          v-bind:binder_type   = "record.binder_type"
          v-bind:warhead_name  = "record.warhead_name"
          v-bind:binder_id     = "record.binder_id"
          v-bind:binder_mol    = "record.binder_img"
          v-bind:adduct_pdb    = "record.adduct_img"
          v-bind:doi           = "record.doi" /> 
      </tbody>
    </table>
  </div>
</template>

<script> 

import recordEntry from './recordEntry.vue'; 

export default {
  name: 'recordList', 
  props: ['recordData', 'section_record_visible'],
  components: {
    recordEntry
  },
  methods: { 
    click_checkbox: function () { 
      this.$emit('click_checkbox', 'download');
    }, 
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
  .title {
    font-size: 2em;
    font-weight: bold;
  }
  .selectAll {
    font-size: 1.5em;
    font-weight: bold;
  }
  a {
    color: #42b983;
  }
</style>
